/**
 * zod 3's `required_error` / `invalid_type_error` for zod 4 (#2151).
 *
 * zod 4's schema-level `error` also replaces the default message of every check
 * without a message of its own (`.min()`, `.email()`, ...). zod 3's two keys
 * answered only the type issue: `required` when the value is missing, `invalid`
 * for any other wrong type. This map keeps that scope. An enum or literal reports
 * a wrong value as `invalid_value`, which is its type issue.
 */
export function typeError(messages: { required?: string; invalid?: string }) {
  return (issue: { code?: string; input?: unknown }): string | undefined => {
    if (issue.code !== "invalid_type" && issue.code !== "invalid_value") {
      return undefined;
    }
    return issue.input === undefined ? messages.required : messages.invalid;
  };
}
